import commonConfig from "@/assets/javascript/config/commonConfig.js";
import store from '@/store/index'
import router from "../router/index.js";
import { GetMenuTree, GetRoleMenuTree } from '@/service/api.js'

/**
 * 获取动态路由
 * @return {Array} 根据后台返回的数据组成路由
 */
export const getRealRouter = async () => {
	let userRouter = await getRouterQuery();
	if(userRouter && userRouter.length) {
		let realRoutes = _getRealRouter(userRouter);
		return realRoutes;
	} else {
		return [];
	}
}

const getRouterQuery = async () =>{
	let permissionList = await GetRoleMenuTree();
	if(permissionList.code == 0 && permissionList.data) {
		return permissionList.data.list
	} else {
		return []
	}
}

/**
 * 根据接口返回的数据组装路由
 * @param  {Array} userRouter 后台返回的用户权限json 
 * @return {Array} realRoutes 根据后台返回的数据组成路由
 */
const _getRealRouter = (userRouter)=>{
	let realRoutes = [];
	userRouter.filter(item => item.menu_route)
	.forEach((item)=>{
		let _r = {
			path: getPath(item.menu_route, 'path'),
			component: _import(item),
			name: getPath(item.menu_route, 'name'),
			meta: {
				name: item.menu_name,
				icon: item.menu_icon, 
			},
			children: item.subset
				? _getRealRouter(item.subset)
				: null
		}
		realRoutes.push(_r)
	})
	return realRoutes;
}

const getPath = (route, type)=>{
	let pathArr = route.split('/');
	let root = ''
	if(pathArr.length == 2 && type == "path") {
		root = '/';
	}
	return root + pathArr[pathArr.length - 1];
}

const _import = (value) => {
	let route = value.menu_route;
	let parent_id = value.parent_id;
	let subset = value.subset;
	// 接口路由如果是前端定义的则返回，不是返回404
	if(commonConfig.allRoute.indexOf(route) != -1) {
		//如果是一级，返回框架页面
		if(parent_id == 0){
			return () => import('../views/layout/layout.vue')
		} else { //否则返回对应页面
			return () => import('../views' + route + '.vue')
		}
	} else {
		//如果是一级
		if(parent_id == 0){
			// 并且有子级，返回框架页面
			if(subset && subset.length) {
				return () => import('../views/layout/layout.vue')
			} else {//否则返回404全页面
				return () => import("../views/status/404.vue")
			}
		} else {
			return () => import("../views/status/404.vue")
		}
	}
}

/**
 * 本地配置好路由，后端返回具体显示哪个路由---开发环境测试使用
 * @param  {Array} userRouter 后台返回的用户权限json
 * @param  {Array} allRouter  前端配置好的所有动态路由的集合
 * @return {Array} realRoutes 过滤后的路由
 */
 export const getRealRouterLocal = (userRouter = [], allRouter = []) => {
	var realRoutes = allRouter
		.filter(item => userRouter.includes(item.name))
		.map(item => ({
			...item,
			children: item.children
				? getRealRouterLocal(userRouter, item.children)
				: null
		}))
	return realRoutes
}

/**
 *跳转路由
 * @param {Object} value 
 */
export const gotoRoute = (value) => {
  let name = value.name;
  router.push({ name, params:{id:value.meta.id}});
  store.commit('setEditableTabsValue',value.name)
  let isHas = false;
  store.getters.getEditableTabs.forEach((item)=>{
    if(item.name == name){
      isHas = true;
    }
  })
  if(!isHas){
    store.commit('addEditableTabs', {
      title: value.meta.name,
      name: value.name,
      closable: true
    }) 
  }
}